import React from 'react';

/**
 * Thin wrapper: hide / relabel / required star from published form config.
 * Falls back to hard-coded defaults when config is unpublished or flagged off.
 */
export const ConfiguredField = ({
  fieldKey,
  formConfig,
  defaultLabel,
  defaultRequired = false,
  className = 'form-group',
  style,
  showLabel = true,
  children,
}) => {
  if (!fieldKey || formConfig?.isHidden?.(fieldKey)) return null;
  const label = formConfig?.labelFor?.(fieldKey, defaultLabel) ?? defaultLabel;
  const required = formConfig?.isRequired?.(fieldKey, defaultRequired) ?? defaultRequired;
  const readOnly = formConfig?.isReadOnly?.(fieldKey) ?? false;
  const help = formConfig?.helpFor?.(fieldKey, '') || '';
  const placeholder = formConfig?.placeholderFor?.(fieldKey, '') || '';

  return (
    <div className={className} style={style} data-config-field={fieldKey}>
      {showLabel && label != null && label !== '' && (
        <label>
          {label}
          {required ? <span className="req"> *</span> : null}
        </label>
      )}
      {typeof children === 'function'
        ? children({ label, required, readOnly, help, placeholder })
        : children}
      {help ? (
        <p style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>{help}</p>
      ) : null}
    </div>
  );
};

export default ConfiguredField;
